(function () {
    'use strict';

    angular
        .module('app.surveys')
        .controller('SurveyResultsController', SurveyResultsController);

    SurveyResultsController.$inject = [
        '$state', '$stateParams', 'common', 'dataservice'
    ];

    function SurveyResultsController($state, $stateParams, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        vm.common = common;
        vm.cancel = cancel;
        vm.surveyResults = [];
        vm.textQuestions = [];
        vm.displayedTextQuestions = [];
        vm.answerDetailsId = '';
        vm.showAnswerDetails = showAnswerDetails;
        vm.chartOptions = {
            legend: { display: true, position: 'bottom' },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var allData = data.datasets[tooltipItem.datasetIndex].data;
                        var tooltipLabel = data.labels[tooltipItem.index];
                        var tooltipData = allData[tooltipItem.index];
                        var total = 0;
                        for (var i in allData) {
                            total += allData[i];
                        }
                        var tooltipPercentage = Math.round((tooltipData / total) * 100);
                        return tooltipLabel + ': ' + tooltipPercentage + '%';
                    }
                }
            }
        };



        activate();

        function activate() {
            var promises = [getItem()];

            return common.$q.all(promises).then(function (data) {

            }, function (error) { });
        }

        function cancel() {
            $state.go("surveys.list");
        }

        function showAnswerDetails($event, item) {
            
            $event.preventDefault();
            $event.stopPropagation();
            vm.answerDetailsId = item.UId;
        }


        function getItem() {
            var surveyUId = $stateParams.id;

            return dataservice.getItem("api/Surveys/Results/" + surveyUId)
                .then(function (response) {
                    if (response) {
                        var data = response.data;
                        vm.title = data.Description;
                        vm.textQuestions = data.TextQuestionResponses;
                        vm.displayedTextQuestions = [].concat(vm.textQuestions);
                        
                        for (var i = 0; i < data.QuestionResponses.length; i++) {
                            if (data.QuestionResponses[i].AnswerType !== 2 && data.QuestionResponses[i].AnswerType !== 1) {
                                vm.surveyResults.push({ Question: data.QuestionResponses[i].Question, ChartData: data.QuestionResponses[i].Data, ChartLabels: data.QuestionResponses[i].Labels });
                            }
                           
                        }
                        

                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }
    }
})();
